import gql from 'graphql-tag';

export const GET_FINANCE_PROGRAMS_BY_ID = gql`
  query FinanceProgram($financeProgramId: ID!) {
    financeProgram(id: $financeProgramId) {
      accountId
      financeProgramId
      nameInternal
      dealerTier
      paymentOptionsConfiguration
      validDateEnd
      validDateStart
      createdDateTime
      modifiedDateTime
      insuranceCoverage {
        coverageRequirements
        certificateRequirements
        otherInstructions
      }
      financeProgramToLenderProfiles {
        financeProgramToLenderProfileId
        lenderProfileId
        isDisabled
      }
      prescreenCriteria {
        prescreenCriteriaId
        accountId
        active
        jsonCriteria
        name
        guidelines
      }
      financeProgramModificationSettings {
        markup
      }
      submissionSettings {
        excludedDocuments
        autoSubmitUserProfileId
      }
      scoreTiers {
        tiers
      }
    }
  }
`;
